import React, { useMemo } from "react";
import moment from "moment";
import { useLocaleContext } from "../../context/LocaleContext";
import './style.scss';

export default ({ block }) => {
    const {get: getLocale, getProperty} = useLocaleContext();
    const className = "cover-block";

    const dateText = useMemo(() => {
        const dateEventStart = moment.unix(block.dateEventStart).startOf('day');
        const dateEventStop = moment.unix(block.dateEventStop).startOf('day');

        if (!block.showDateEvent || !block.dateEventStart) {
            return '';
        }

        let text = dateEventStart.format('DD MMMM YYYY');

        if (block.dateEventStop && !dateEventStop.isSame(dateEventStart)) {
            text += ` - ${dateEventStop.format('DD MMMM YYYY')}`;
        }

        return text;
    }, [block]);

    const style = {
        backgroundImage: `url(${block.imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    }

    return (
        <section className={`page-block ${className}`} style={style}>
            <div className={`${className}-wrapper`}>
                <div className={`${className}-head`}>
                    {block.showDateEvent && (
                        <span className={`${className}-element`}>
                            {dateText}
                        </span>
                    )}
                    {block.showTimeEvent && (
                        <span className={`${className}-element`}>
                            {block.timeEvent}
                        </span>
                    )}
                    {block.showParticipationType && (
                        <span className={`${className}-element`}>
                            {getLocale(`participationType.${block.participationType}`)}
                        </span>
                    )}
                </div>
                
                <h1>{getProperty(block, 'title')}</h1>
                <p>{getProperty(block, 'subtitle')}</p>
            </div>
        </section>
    );
};
